import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import {
    authState,
    distributionTypeState,
} from 'store/state';
import {
    useAuthActions,
    useAddressesActions,
} from 'services';
import { webLibSdk } from 'helpers';

import { METAMASK } from '_constants/loginTypes';

const useInit = () => {
    const [auth] = useRecoilState(authState);
    const [distributionType] = useRecoilState(distributionTypeState);
    const { login } = useAuthActions();
    const { getAddresses } = useAddressesActions();

    useEffect(() => {
        const init = async () => {
            const isConnected = await webLibSdk.isConnected();
            if (isConnected || !auth) {
                getAddresses();
                return;
            }
            await login(auth.loggedInWith === METAMASK);
        };
        init();
    }, [distributionType]); // eslint-disable-line
};

export default useInit;
